var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientsTreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4129 11.6507C17.0644 10.4333 18.0511 8.49132 18.0511 6.45619C18.0511 2.89661 15.1549 0 11.5946 0C8.03465 0 5.1384 2.89625 5.1384 6.45619C5.1384 8.51947 6.09841 10.4113 7.77191 11.6478C1.1876 13.976 0.15975 22.0093 0.00131387 24.4158C-0.00987412 24.5887 0.0507576 24.7583 0.169134 24.885C0.28751 25.0113 0.452442 25.0831 0.625315 25.0831H22.5639C22.7367 25.0831 22.9024 25.0113 23.0208 24.885C23.1392 24.7583 23.1998 24.589 23.1886 24.4158C23.0298 22.014 21.9994 13.9929 15.4129 11.6507Z",
    fill: "#52447D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9634 11.9539C25.0533 11.1502 25.7033 9.86826 25.7033 8.52462C25.7033 6.17586 23.7916 4.26416 21.4421 4.26416C20.7683 4.26416 20.1331 4.42548 19.5658 4.70554C19.6903 5.27 19.7567 5.85466 19.7567 6.45664C19.7567 8.14567 19.2211 9.78381 18.2637 11.1441C22.0344 13.5159 23.6704 17.6656 24.3788 20.8199H28.6819C28.7955 20.8199 28.9049 20.7726 28.9836 20.6896C29.0612 20.6066 29.1009 20.4943 29.0936 20.3803C28.9897 18.7934 28.3101 13.4997 23.9634 11.9539Z",
    fill: "#52447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsTreated);
export default __webpack_public_path__ + "static/media/patientsTreated.aca04bbc39b777d1178d14f237689655.svg";
export { ForwardRef as ReactComponent };